<div id="history-frame">
    <div class="grid-split-2">
        <div>
            <h2>
                Balance
                <span *ngIf="!lastHistory">{{ "0" | currency }}</span>
                <span *ngIf="lastHistory">{{
                    lastHistory.balance | currency
                }}</span>
            </h2>
        </div>
        <div>
            <button
                (click)="withdrawal()"
                *ngIf="lastHistory && lastHistory.balance > 0 && false"
                class="btn btn-sm btn-primary"
            >
                Withdraw Request
            </button>
        </div>
    </div>

    <table mat-table [dataSource]="historyModels" class="table-list">
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let historyModel">
                {{ historyModel.id }}
            </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let historyModel">
                {{ historyModel.created_at | date: "short" }}
            </td>
        </ng-container>

        <ng-container matColumnDef="transaction">
            <th mat-header-cell *matHeaderCellDef>Transaction</th>
            <td mat-cell *matCellDef="let historyModel">
                {{ historyModel.tx!.transaction_type | humancase }} (#{{
                    historyModel.transaction
                }})
            </td>
        </ng-container>

        <ng-container matColumnDef="result">
            <th mat-header-cell *matHeaderCellDef>Result</th>
            <td mat-cell *matCellDef="let historyModel">
                {{ historyModel.tx!.result | titlecase }}
            </td>
        </ng-container>

        <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let historyModel">
                <span
                    [ngClass]="{
                        'tx-credit': true,
                        'tx-debit':
                            openIdProfile!.id ==
                            historyModel.tx!.sender_open_id,
                        'tx-not-approved': historyModel.tx!.result != 'APPROVED'
                    }"
                    >{{
                        historyModel.tx!.amount *
                            (openIdProfile!.id ==
                            historyModel.tx!.sender_open_id
                                ? -1
                                : 1) | currency
                    }}</span
                >
            </td>
        </ng-container>

        <ng-container matColumnDef="balance">
            <th mat-header-cell *matHeaderCellDef>Balance</th>
            <td mat-cell *matCellDef="let historyModel">
                {{ historyModel.balance | currency }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnHeadings"></tr>
        <tr mat-row *matRowDef="let row; columns: columnHeadings"></tr>
    </table>

    <div class="grid-split-2" style="align-items: center">
        <div>
            <button class="btn btn-sm btn-success" (click)="reload()">
                <i class="bi bi-arrow-clockwise"></i>
            </button>
        </div>
        <div>
            <mat-paginator
                [length]="pagingItemCount"
                [pageSize]="pagingPageSize"
                showFirstLastButtons
            >
            </mat-paginator>
        </div>
    </div>
</div>
